export const DEFAULT_SIZE_FACTOR = 1;
export const DEFAULT_IMAGE_COMPRESSION = null;
export const DEFAULT_IMAGE_MIRROR = false;
